import { apiClient } from '../../services/apiClient';
import type {
  PlansResponse,
  CurrentSubscription,
  CheckoutResponse,
  ChangeResponse,
  CancelResponse,
} from './types';

/**
 * 利用可能なプラン一覧を取得
 */
export async function getPlans(): Promise<PlansResponse> {
  const response = await apiClient.get<PlansResponse>('/subscriptions/plans');
  return response.data;
}

/**
 * 現在の契約情報を取得
 */
export async function getCurrentSubscription(): Promise<CurrentSubscription> {
  const response = await apiClient.get<CurrentSubscription>('/subscriptions/current');
  return response.data;
}

/**
 * Stripe Checkoutセッションを作成（新規契約・アップグレード）
 */
export async function createCheckoutSession(planCode: string): Promise<CheckoutResponse> {
  const response = await apiClient.post<CheckoutResponse>('/subscriptions/checkout', {
    plan_code: planCode,
  });
  return response.data;
}

/**
 * プラン変更（ダウングレード予約）
 */
export async function changePlan(planCode: string): Promise<ChangeResponse> {
  const response = await apiClient.post<ChangeResponse>('/subscriptions/change', {
    plan_code: planCode,
  });
  return response.data;
}

/**
 * 解約予約
 */
export async function cancelSubscription(): Promise<CancelResponse> {
  const response = await apiClient.post<CancelResponse>('/subscriptions/cancel');
  return response.data;
}

/**
 * 解約予約の取り消し（フリープランへのダウングレード予約を取り消し）
 */
export async function revertCancellation(): Promise<CancelResponse> {
  const response = await apiClient.delete<CancelResponse>('/subscriptions/cancel');
  return response.data;
}

/**
 * プラン変更予約の取り消し（有料プラン間のダウングレード予約を取り消し）
 */
export async function cancelScheduledChange(): Promise<CancelResponse> {
  const response = await apiClient.delete<CancelResponse>('/subscriptions/scheduled-change');
  return response.data;
}
